import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppService {

constructor(private http: HttpClient) {
    this.clientId = environment.auth.clientId;
    this.clientSecret = environment.auth.secret;
}

  private clientId;
  private clientSecret;
  private token = null;

  retrieveToken() {
    if(this.token) {
      let observableToken = new Observable(observer => {
        observer.next({access_token: this.token});
      });

      return observableToken;
    }

    let params = new URLSearchParams();
    params.append('grant_type','client_credentials');

    let headers =
      new HttpHeaders({
        'Content-type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic ' + window.btoa(`${this.clientId}:${this.clientSecret}`)
      });

    return this.http.post(`${environment.serviceUrl}/uaa/oauth/token`, params.toString(), { headers: headers });
  }

  setToken(token) {
    this.token = token;
  }
}
